import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
  HeaderFilter,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import FileUploader from "devextreme-react/file-uploader";
import { Button } from "devextreme-react";
import notify from "devextreme/ui/notify";
import { useScreenSize } from "../../../utils/media-query";
import {
  listApprovalType,
  changeDisplayedName,
  generateBlobLink,
  axios,
  handleExportExcel,
} from "../../../common";
import PopupConfig from "../../../common/popup";

export default function ApprovalSettingTableList({
  dataGridRef,
  middleware,
  onSelectionChanged,
  dataTable,
  handleAction,
  selectedRowKeys,
  cellEditRender,
  setIsLoading,
  levelColumns,
}) {
  const [errorPath, setErrorPath] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const { isXSmall, isSmall } = useScreenSize();
  const [clicked, setClicked] = React.useState(false);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  const handleImportExcel = async (e) => {
    if (clicked) return;
    setClicked(true);
    setIsLoading(true);
    try {
      if (!file) {
        notify("Please select file to import", "error", 3000);
        setIsLoading(false);
        setClicked(false);
        return;
      }
      const formData = new FormData();
      formData.append("fileName", file);
      const { headers, data } = await axios.post(
        "ApprovalSetting/ImportFile",
        formData,
        {
          responseType: "arraybuffer",
        }
      );
      setClicked(false);
      if (data.byteLength === 2) {
        notify("Import thành công", "success", 3000);
        handleAction("refresh");
        setIsLoading(false);
        handleClosePopup();
        return;
      }
      const relsUrl = generateBlobLink(data, headers["content-type"]);

      setErrorPath(relsUrl);
      notify(`Import thiêt lập phê duyệt không thành công`, "error", 3000);
      setIsLoading(false);
      handleAction("refresh");
    } catch (error) {
      var enc = new TextDecoder("utf-8");
      var arr = enc.decode(error.response.data);
      setIsLoading(false);
      notify(JSON.parse(arr).message, "error", 3000);
      setClicked(false);
    }
    // setOvertime(data.value);
  };

  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <FileUploader
          selectButtonText="Select file"
          labelText=""
          accept=".xlsx, .xls"
          maxFileSize={5000000}
          uploadMode="useForm"
          onValueChanged={(e) => {
            // check file size and type
            if (e.value.length > 0) {
              if (e.value[0].size > 5000000) {
                notify("File size must be less than 5MB", "error", 3000);
                return;
              }
              if (
                e.value[0].type !==
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                e.value[0].type !== "application/vnd.ms-excel"
              ) {
                notify("File type must be .xlsx or .xls", "error", 3000);
                return;
              }

              setFile(e.value[0]);
            }
          }}
        />
        {errorPath && (
          <div style={{ color: "red", marginTop: "10px" }}>
            <a href={errorPath} download="ApprovalSettingImportError.xlsx">
              Download Error File
            </a>
          </div>
        )}
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleImportExcel}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={() => {
            setClicked(false);
            handleClosePopup();
          }}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      {popupConfig.popupVisible && renderViewPopup()}
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={dataGridRef}
        dataSource={dataTable}
        onSelectionChanged={onSelectionChanged}
      >
        {/* <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        /> */}
        <HeaderFilter visible={true} />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {middleware && middleware.WriteState === true && (
          <Column
            width={120}
            caption={formatMessage("Action")}
            alignment="center"
            allowSearch={false}
            cellRender={cellEditRender}
          />
        )}

        <Column
          caption={formatMessage("ApprovalType")}
          dataField="ApprovalType"
          dataType="number"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={listApprovalType}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="Employee"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        {levelColumns.map((item, index) => {
          return (
            <Column
              caption={item.levelName}
              dataField={item.levelName}
              dataType="string"
              key={item.levelName}
              hidingPriority={isXSmall || isSmall ? 4 : false}
            />
          );
        })}

        <Column
          caption={formatMessage("Description")}
          dataField="Description"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("IsActive")}
          dataField="IsActive"
          dataType="boolean"
          hidingPriority={isXSmall || isSmall ? 6 : false}
          allowFiltering={false}
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            {middleware && middleware.ExportState && (
              <Button
                icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#000000"/></svg>`}
                text={formatMessage("ExportFileDefault")}
                onClick={() => {
                  // download file mẫu from public
                  window.open(
                    "/assets/eCap_Template_Import_ApprovalSetting.xlsx"
                  );
                }}
                className="mr-1"
              />
            )}
            {middleware && middleware.ExportState && (
              <Button
                icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#000000"/></svg>`}
                text={formatMessage("Export")}
                onClick={() =>
                  handleExportExcel(dataGridRef, "ApprovalSettingEmployee")
                }
                className="mr-1"
              />
            )}
            {middleware && middleware.ImportState && (
              <Button
                icon="import"
                text={formatMessage("Import")}
                onClick={handleOpenPopup}
                className="mr-1"
              />
            )}
            {/* {selectedRowKeys.length > 0 &&
              middleware &&
              middleware.DeleteState && (
                <Button
                  icon="trash"
                  text={formatMessage("Delete")}
                  type="danger"
                  stylingMode="outlined"
                  className="mr-1"
                  onClick={() => handleAction("delete")}
                />
              )}
            {selectedRowKeys.length === 1 &&
              middleware &&
              middleware.WriteState && (
                <Button
                  icon="edit"
                  text={formatMessage("Edit")}
                  className="mr-1"
                  onClick={() => handleAction("edit")}
                />
              )} */}
            {/* <Button
              icon="revert"
              text={formatMessage("Refresh")}
              className="mr-1"
              onClick={() => handleAction("refresh")}
            /> */}
            <Button
              icon="plus"
              text={formatMessage("Create")}
              type="default"
              stylingMode="outlined"
              onClick={() => handleAction("add")}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
